import React, { useState, useEffect, useCallback } from "react";
import { API_URL } from "../../utils/config";
import { mapejos } from "../../utils/Mapejos";
import { useUserContext } from "../../utils/UserContext";
import TeclaEscEnter from "../../utils/Teclaescenter";
import AjudaTreball from "./AjudaTreball";
import { BotoAjuda } from "./AjudaModal";
import "../dashboard_v2.css";

function Agrupacions({ treball, onCancel, subnav }) {
  const [agrupacionsList, setAgrupacionsList] = useState([]);
  const [selectedAgrup, setSelectedAgrup] = useState(null);
  const [tasquesList, setTasquesList] = useState([]);
  const [mode, setMode] = useState("normal");
  const [formAgrup, setFormAgrup] = useState({ NomAgrupacio: "", Descripcio: "", Estat: "Pendent", Ordre: "" });
  const [editingAgrupId, setEditingAgrupId] = useState(null);

  const [selectedTasquesIds, setSelectedTasquesIds] = useState([]);
  const [fDescripcio, setFDescripcio] = useState("");
  const [fCategoria, setFCategoria] = useState("");

  const { usuariActiu } = useUserContext();
  const [mostraAjuda, setMostraAjuda] = useState(false);

  TeclaEscEnter(mode === "normal" ? onCancel : () => setMode("normal"), null);

  const fetchAgrupacions = useCallback(async () => {
    if (!treball?.idTreballs) return;
    try {
      const resp = await fetch(`${API_URL}/AgrupacionsTreball.php`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ idTreballs: treball.idTreballs }),
      });
      const data = await resp.json();
      if (data.success) setAgrupacionsList(data.agrupacions || []);
    } catch (err) {
      console.error("Error carregant agrupacions:", err);
    }
  }, [treball]);

  const fetchTasques = useCallback(async () => {
    if (!treball?.idTreballs) return;
    try {
      const resp = await fetch(`${API_URL}/TasquesTreball.php`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ idTreballs: treball.idTreballs }),
      });
      const data = await resp.json();
      if (data.success) setTasquesList(data.tasques || []);
    } catch (err) {
      console.error("Error carregant tasques:", err);
    }
  }, [treball]);

  useEffect(() => {
    fetchAgrupacions();
    fetchTasques();
  }, [fetchAgrupacions, fetchTasques]);

  // Tasques a mostrar segons mode i selecció
  const getTasquesPerMostrar = () => {
    if (mode === "agrupar" && selectedAgrup) {
      // Mode agrupar: només lliures + les que ja pertanyen a l'agrupació seleccionada
      return tasquesList.filter((t) => {
        const agrupId = t.AgrupacionsTreball_idAgrupacionsTreball;
        if (agrupId && agrupId !== selectedAgrup.idAgrupacionsTreball) return false;
        if (fDescripcio && !(t.DescripcioTasca || "").toLowerCase().includes(fDescripcio.toLowerCase())) return false;
        if (fCategoria && (t.Categoria || "") !== fCategoria) return false;
        return true;
      });
    }

    if (!selectedAgrup) {
      // Sense agrupació seleccionada: totes les tasques
      return tasquesList;
    }

    // Agrupació seleccionada en mode normal
    return tasquesList.filter((t) => t.AgrupacionsTreball_idAgrupacionsTreball === selectedAgrup.idAgrupacionsTreball);
  };

  const categories = [...new Set(tasquesList.map((t) => t.Categoria).filter(Boolean))];

  const toggleTascaSelect = (idTasca) => {
    setSelectedTasquesIds((prev) =>
      prev.includes(idTasca) ? prev.filter((id) => id !== idTasca) : [...prev, idTasca]
    );
  };

  const handleCrearAgrupacio = async () => {
    if (!formAgrup.NomAgrupacio.trim()) {
      alert("El nom de l'agrupació és obligatori.");
      return;
    }
    try {
      const resp = await fetch(`${API_URL}/Novaagrupacio.php`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          Treballs_idTreballs: treball.idTreballs,
          NomAgrupacio: formAgrup.NomAgrupacio,
          Descripcio: formAgrup.Descripcio,
          Estat: formAgrup.Estat,
          Ordre: formAgrup.Ordre,
          Usuaris_idUsuaris: usuariActiu || 1,
        }),
      });
      const data = await resp.json();
      if (data.success) {
        setFormAgrup({ NomAgrupacio: "", Descripcio: "", Estat: "Pendent", Ordre: "" });
        setMode("normal");
        fetchAgrupacions();
      } else {
        alert(data.message || "Error creant agrupació.");
      }
    } catch (err) {
      alert("Error de connexió.");
    }
  };

  const handleEditarAgrupacio = async () => {
    if (!editingAgrupId) return;
    const anterior = agrupacionsList.find((a) => a.idAgrupacionsTreball === editingAgrupId);
    if (formAgrup.Estat === "Acabada" && anterior?.Estat !== "Acabada") {
      const confirmar = window.confirm(
        "Això acaba les tasques obertes d'aquesta agrupació. No es demanen dates: si falta la data final, serà avui; si falta l'inici real, s'usa la data prevista. Les cícliques generaran la següent ronda i l'agrupació tornarà a pendent."
      );
      if (!confirmar) return;
    }
    try {
      const resp = await fetch(`${API_URL}/Modificaragrupacio.php`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          idAgrupacionsTreball: editingAgrupId,
          NomAgrupacio: formAgrup.NomAgrupacio,
          Descripcio: formAgrup.Descripcio,
          Estat: formAgrup.Estat,
          Ordre: formAgrup.Ordre,
        }),
      });
      const data = await resp.json();
      if (data.success) {
        setEditingAgrupId(null);
        setFormAgrup({ NomAgrupacio: "", Descripcio: "", Estat: "Pendent", Ordre: "" });
        setMode("normal");
        fetchAgrupacions();
        fetchTasques();
      } else {
        alert(data.message || "Error modificant agrupació.");
      }
    } catch (err) {
      alert("Error de connexió.");
    }
  };

  const handleEsborrarAgrupacio = async (idAgrup) => {
    if (!window.confirm("Estàs segur? Les tasques es desvincularan de l'agrupació.")) return;
    try {
      const resp = await fetch(`${API_URL}/Esborraragrupacio.php`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ idAgrupacionsTreball: idAgrup }),
      });
      const data = await resp.json();
      if (data.success) {
        if (selectedAgrup?.idAgrupacionsTreball === idAgrup) setSelectedAgrup(null);
        fetchAgrupacions();
        fetchTasques();
      } else {
        alert(data.message || "Error esborrant agrupació.");
      }
    } catch (err) {
      alert("Error de connexió.");
    }
  };

  const handleAssignar = async () => {
    if (!selectedAgrup || selectedTasquesIds.length === 0) {
      alert("Selecciona una agrupació i almenys una tasca.");
      return;
    }
    try {
      const resp = await fetch(`${API_URL}/AssignarAgrupacio.php`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          idAgrupacionsTreball: selectedAgrup.idAgrupacionsTreball,
          idTasques: selectedTasquesIds,
        }),
      });
      const data = await resp.json();
      if (data.success) {
        setSelectedTasquesIds([]);
        setMode("normal");
        fetchAgrupacions();
        fetchTasques();
      } else {
        alert(data.message || "Error assignant tasques.");
      }
    } catch (err) {
      alert("Error de connexió.");
    }
  };

  // Desassignar tasques de l'agrupació (deixar-les lliures)
  const handleDesassignar = async (idsTasques) => {
    if (!idsTasques || idsTasques.length === 0) return;
    try {
      const resp = await fetch(`${API_URL}/AssignarAgrupacio.php`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          idAgrupacionsTreball: null,
          idTasques: idsTasques,
        }),
      });
      const data = await resp.json();
      if (data.success) {
        setSelectedTasquesIds([]);
        fetchAgrupacions();
        fetchTasques();
      } else {
        alert(data.message || "Error desassignant.");
      }
    } catch (err) {
      alert("Error de connexió.");
    }
  };

  const startEditar = (agrup) => {
    setEditingAgrupId(agrup.idAgrupacionsTreball);
    setFormAgrup({
      NomAgrupacio: agrup.NomAgrupacio || "",
      Descripcio: agrup.Descripcio || "",
      Estat: agrup.Estat || "Pendent",
      Ordre: agrup.Ordre ?? "",
    });
    setMode("editarAgrup");
  };

  const handleAgrupClick = (ag) => {
    // Permet deseleccionar clicant de nou
    setSelectedAgrup((prev) =>
      prev?.idAgrupacionsTreball === ag.idAgrupacionsTreball ? null : ag
    );
  };

  const camp = (label, control, size = "mig") => (
    <label className={`dv2-field dv2-field--${size}`}>
      <span className="dv2-label">{label}</span>
      {control}
    </label>
  );

  const renderFormAgrup = () => (
    <section className="dv2-card">
      <h2 className="dv2-card-title">{mode === "novaAgrup" ? "Nova agrupació" : "Editar agrupació"}</h2>
      <div className="dv2-fields dv2-fields--sizes">
        {camp("Nom", <input className="dv2-input" type="text" value={formAgrup.NomAgrupacio} onChange={(e) => setFormAgrup((p) => ({ ...p, NomAgrupacio: e.target.value }))} />, "llarg")}
        {camp("Descripció", <textarea className="dv2-textarea" value={formAgrup.Descripcio} onChange={(e) => setFormAgrup((p) => ({ ...p, Descripcio: e.target.value }))} rows={2} />, "ample")}
        {camp("Estat", (
          <select className="dv2-select" value={formAgrup.Estat} onChange={(e) => setFormAgrup((p) => ({ ...p, Estat: e.target.value }))}>
            {Object.entries(mapejos.estatAgrupacio).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
          </select>
        ), "mig")}
        {camp("Ordre", <input className="dv2-input" type="number" value={formAgrup.Ordre} onChange={(e) => setFormAgrup((p) => ({ ...p, Ordre: e.target.value }))} />, "curt")}
      </div>
      <div className="dv2-footerActions">
        <button type="button" className="dv2-btn" onClick={() => { setMode("normal"); setEditingAgrupId(null); }}>Cancel·lar</button>
        <button type="button" className="dv2-btn dv2-btn--primary" onClick={mode === "novaAgrup" ? handleCrearAgrupacio : handleEditarAgrupacio}>Guardar</button>
      </div>
    </section>
  );

  const renderTasquesTable = (tasques, multiSelect) => {
    if (tasques.length === 0) return <p className="dv2-empty">No hi ha tasques.</p>;

    const jaAgrupada = (t) => mode === "agrupar" && selectedAgrup &&
      t.AgrupacionsTreball_idAgrupacionsTreball === selectedAgrup.idAgrupacionsTreball;

    return (
      <div className="dv2-tableWrap">
        <table className="dv2-table">
          <thead>
            <tr>
              {multiSelect && <th className="dv2-col-expand"></th>}
              <th className="dv2-num">Qtat.</th>
              <th>Unitats</th>
              <th>Descripció</th>
              <th>Estat</th>
              {!multiSelect && <th>Agrupació</th>}
              {multiSelect && selectedAgrup && <th className="dv2-table-actions">Treure</th>}
            </tr>
          </thead>
          <tbody>
            {tasques.map((t) => {
              const isSel = multiSelect && selectedTasquesIds.includes(t.idTasques);
              const isJaAgrupada = jaAgrupada(t);

              return (
                <tr
                  key={t.idTasques}
                  className={isSel ? "is-selected" : ""}
                  onClick={() => multiSelect && !isJaAgrupada && toggleTascaSelect(t.idTasques)}
                >
                  {multiSelect && (
                    <td>
                      {!isJaAgrupada && (
                        <input
                          type="checkbox"
                          checked={isSel}
                          onChange={() => toggleTascaSelect(t.idTasques)}
                          onClick={(e) => e.stopPropagation()}
                        />
                      )}
                    </td>
                  )}
                  <td className="dv2-num">{t.Quantitat ?? "—"}</td>
                  <td>{t.Unitats || "—"}</td>
                  <td className="dv2-cell-clip" style={{ paddingLeft: t.idTascaPare ? 20 : undefined }}>
                    {t.DescripcioTasca || "—"}
                    {isJaAgrupada ? " · ja al grup" : ""}
                  </td>
                  <td>{mapejos.estatTasca[t.Estat] || t.Estat}</td>
                  {!multiSelect && <td>{t.NomAgrupacio || "—"}</td>}
                  {multiSelect && selectedAgrup && (
                    <td className="dv2-table-actions">
                      {isJaAgrupada && (
                        <button
                          type="button"
                          className="dv2-btn"
                          title="Treure de l'agrupació"
                          onClick={(e) => { e.stopPropagation(); handleDesassignar([t.idTasques]); }}
                        >Treure</button>
                      )}
                    </td>
                  )}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    );
  };

  const tasquesPerMostrar = getTasquesPerMostrar();

  return (
    <div className="dv2-entity">
      {mostraAjuda && <AjudaTreball pestanya="agrupacions" onTancar={() => setMostraAjuda(false)} />}
      <div className="dv2-pageHeader">
        <div className="dv2-pageHeader-main">
          <div className="dv2-pageHeader-icon" aria-hidden="true">🗂️</div>
          <div>
            <h1 className="dv2-pageHeader-title">Agrupacions</h1>
            <p className="dv2-pageHeader-subtitle">
              {treball?.idTreballIntern || treball?.idTreballs}
              {treball?.NomClient ? ` · ${treball.NomClient}` : ""}
              {mode === "agrupar" && selectedAgrup ? ` · Mode agrupar: ${selectedAgrup.NomAgrupacio}` : ""}
            </p>
          </div>
        </div>
        <div className="dv2-pageHeader-actions">
          <BotoAjuda title="Com funcionen les Agrupacions" onClick={() => setMostraAjuda(true)} />
          <button type="button" className="dv2-btn" onClick={onCancel}>Tornar</button>
        </div>
      </div>
      {subnav}
      <div className="dv2-entity-body">

      {(mode === "novaAgrup" || mode === "editarAgrup") && renderFormAgrup()}

      {(mode === "normal" || mode === "agrupar") && (
        <div className="dv2-split">
          <div>
            <div className="dv2-split-tools">
              <button type="button" className="dv2-btn dv2-btn--icon dv2-btn--primary" title="Nova agrupació" onClick={() => { setFormAgrup({ NomAgrupacio: "", Descripcio: "", Estat: "Pendent", Ordre: "" }); setMode("novaAgrup"); }}>
                +
              </button>
              <button type="button" className="dv2-btn dv2-btn--icon" title="Editar agrupació" disabled={!selectedAgrup} onClick={() => selectedAgrup && startEditar(selectedAgrup)}>
                ✎
              </button>
              <button type="button" className="dv2-btn dv2-btn--icon" title="Esborrar agrupació" disabled={!selectedAgrup} onClick={() => selectedAgrup && handleEsborrarAgrupacio(selectedAgrup.idAgrupacionsTreball)}>
                ✕
              </button>
              <button
                type="button"
                className={`dv2-btn dv2-btn--mode ${mode === "agrupar" ? "dv2-btn--primary" : ""}`}
                title={mode === "agrupar" ? "Sortir del mode agrupar" : "Posar tasques a l'agrupació"}
                disabled={!selectedAgrup}
                onClick={() => {
                  if (mode === "agrupar") { setMode("normal"); setSelectedTasquesIds([]); }
                  else { setMode("agrupar"); setSelectedTasquesIds([]); }
                }}
              >
                {mode === "agrupar" ? "Sortir" : "Agrupar"}
              </button>
            </div>
            {agrupacionsList.length === 0 && <p className="dv2-empty">Cap agrupació.</p>}
            {agrupacionsList.map((ag) => (
              <button
                type="button"
                key={ag.idAgrupacionsTreball}
                className={`dv2-record ${selectedAgrup?.idAgrupacionsTreball === ag.idAgrupacionsTreball ? "is-selected" : ""}`}
                onClick={() => handleAgrupClick(ag)}
              >
                <span className="dv2-record-title">{ag.NomAgrupacio}</span>
                <span className="dv2-record-meta">
                  {mapejos.estatAgrupacio[ag.Estat] || ag.Estat} · {ag.NumTasques || 0} tasques
                  {ag.Ordre != null ? ` · #${ag.Ordre}` : ""}
                </span>
              </button>
            ))}
          </div>

          <div>
            {mode === "agrupar" ? (
              <>
                <div className="dv2-filterBar">
                  <label className="dv2-filter dv2-filter--grow">
                    <span className="dv2-filter-label">Descripció</span>
                    <input className="dv2-input" type="text" value={fDescripcio} onChange={(e) => setFDescripcio(e.target.value)} placeholder="Cercar…" />
                  </label>
                  <label className="dv2-filter">
                    <span className="dv2-filter-label">Categoria</span>
                    <select className="dv2-select" value={fCategoria} onChange={(e) => setFCategoria(e.target.value)}>
                      <option value="">Totes</option>
                      {categories.map((c) => <option key={c} value={c}>{c}</option>)}
                    </select>
                  </label>
                  <span className="dv2-hint">{selectedTasquesIds.length} seleccionades</span>
                </div>
                {renderTasquesTable(tasquesPerMostrar, true)}
                <div className="dv2-footerActions">
                  <button type="button" className="dv2-btn" onClick={() => { setMode("normal"); setSelectedTasquesIds([]); }}>
                    Cancel·lar
                  </button>
                  <button type="button" className="dv2-btn dv2-btn--primary" disabled={selectedTasquesIds.length === 0} onClick={handleAssignar}>
                    Assignar
                  </button>
                </div>
              </>
            ) : (
              <>
                {selectedAgrup ? (
                  <p className="dv2-hint">
                    <strong>{selectedAgrup.NomAgrupacio}</strong>
                    {selectedAgrup.Descripcio ? ` · ${selectedAgrup.Descripcio}` : ""}
                  </p>
                ) : (
                  <p className="dv2-hint">Totes les tasques del treball. Selecciona una agrupació per filtrar.</p>
                )}
                {renderTasquesTable(tasquesPerMostrar, false)}
              </>
            )}
          </div>
        </div>
      )}

      </div>
    </div>
  );
}

export default Agrupacions;
